import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

const pdvClient = axios.create({
  baseURL: window.location.origin,
  withCredentials: true,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
});

export const api = {
  listarEmpresas: () => client.get("/empresas").then((r) => r.data),
  sincronizarCadastroPdv: () =>
    pdvClient.post("/internal/sintegra-sync-pdv").then((r) => r.data),
  criarEmpresa: (data) => client.post("/empresas", data).then((r) => r.data),
  obterEmpresa: (id) => client.get(`/empresas/${id}`).then((r) => r.data),
  excluirEmpresa: (id) => client.delete(`/empresas/${id}`).then((r) => r.data),
  regenerarChaves: (id) => client.post(`/empresas/${id}/regenerar-chaves`).then((r) => r.data),
  dadosEmpresa: (id, competencia) =>
    client.get(`/empresas/${id}/dados`, { params: { competencia } }).then((r) => r.data),
  gerar: (id, competencia) =>
    client.post(`/empresas/${id}/gerar`, null, { params: { competencia } }).then((r) => r.data),
  listarArquivos: (id) => client.get(`/empresas/${id}/arquivos`).then((r) => r.data),
  portalContador: (token) => client.get(`/contador/${token}`).then((r) => r.data),
};

export const downloadArquivoUrl = (arquivoId) => `${API}/arquivos/${arquivoId}/download`;
export const downloadContadorUrl = (token, arquivoId) => `${API}/contador/${token}/download/${arquivoId}`;
